<template>
    <modal name="update_model" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update model')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <model-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import MakesModelsService from '@services/makesModels.service';
import ModelForm from './components/ModelForm';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                make_id: null,
                name: null,
            },
            loading: false,
            model_id: null,
            makeIndex: null
        };
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    MakesModelsService.updateModel(this.model_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setModel', {model: res, makeIndex: this.makeIndex});
                    });
                }
            });
        },
        beforeOpen(event) {
            const model = event.params.model;
            this.makeIndex = event.params.makeIndex;
            if (model) {
                this.form.make_id = model.make_id;
                this.form.name = model.name;
                this.model_id = model.id;
            }
        },
        hide() {
            this.$modal.hide('update_model');
        }
    },
    components: {
        ModelForm
    }
};
</script>
